import { DocumentNode, gql } from '@apollo/client'

export const CREATE_SLOT_REQUEST: DocumentNode = gql`
    mutation createSlotRequest(
        $daycare_id: Int!
        $child_id: Int!
        $date: Date!
        $start: Time!
        $end: Time!
        $comment: String
    ) {
        createSlotRequest(
            daycare_id: $daycare_id
            child_id: $child_id
            date: $date
            start: $start
            end: $end
            comment: $comment
        )
    }
`

export const CANCEL_SLOT_REQUEST: DocumentNode = gql`
    mutation cancelSlotRequest($id: Int!, $daycare_id: Int!, $child_id: Int!) {
        cancelSlotRequest(request_id: $id, daycare_id: $daycare_id, child_id: $child_id)
    }
`

export const CONFIRM_SLOT_REQUEST: DocumentNode = gql`
    mutation confirmSlotRequest($id: Int!, $accepted: Boolean!, $comment: String, $daycare_id: Int!) {
        confirmSlotRequest(request_id: $id, accepted: $accepted, comment: $comment, daycare_id: $daycare_id)
    }
`

export const GET_SLOT_REQUEST: DocumentNode = gql`
    query GetRequestSlots($daycare_id: Int!, $from: Date, $to: Date) {
        getRequestSlots(daycare_id: $daycare_id, from: $from, to: $to) {
            id
            daycareId
            childId
            childName
            childComplement
            sectionName
            comment
            date
            start
            end
            parentId
            parentName
            requestDate
        }
    }
`
